import { pricesStateStore } from 'rp-prices-component';

export default function sort(array, compareFn) {
    const indexArray = Array.from(new Array(array.length)).map((item, index) => index);
    indexArray.sort((a, b) => compareFn(array[a], array[b]));
    const result = array.map(item => ({ ...item }));
    indexArray.forEach((item, index) => {
        result[item].order = index;
    });
    return result;
}

const isEmpty = (val) => {
    if (Number.isNaN(val) || val === null || val === undefined) {
        return true;
    }
    const type = typeof val;
    if (type === 'number' || type === 'boolean') {
        return false;
    }
    return !val.trim();
};

export const literalSortFn = (key, defaultSortFn) =>
    (a, b) => {
        if (a[key] === b[key]) {
            return defaultSortFn ? defaultSortFn(a, b) : 0;
        }
        if (isEmpty(a[key])) {
            return 1;
        }
        if (isEmpty(b[key])) {
            return -1;
        }
        return a[key] > b[key] ? 1 : -1;
    };

export const numericSortFn = (key, defaultSortFn) =>
    (a, b) => {
        if (a[key] === b[key]) {
            return defaultSortFn ? defaultSortFn(a, b) : 0;
        }
        if (isEmpty(a[key])) {
            return 1;
        }
        if (isEmpty(b[key])) {
            return -1;
        }
        return b[key] - a[key];
    };

function getPriceSortValue(item) {
    if (!item.bookmaker) {
        return 9999;
    }
    const raceInfo = pricesStateStore.getRaceInfo({
        bookmaker: item.bookmaker,
        raceTime: item.diffusionTime,
        raceDate: item.date,
        courseName: item.courseName,
    });

    const raceSuspendState = raceInfo && raceInfo.suspendState;
    if ([item.status, raceSuspendState].includes('H')) {
        // -
        return 9998;
    }
    if (!item.decimalPrice && !item.fractionalPrice) {
        // no price
        return 9999;
    }
    if (!item.decimalPrice) {
        // SP
        return 9997;
    }
    return Number.parseFloat(item.decimalPrice);
}
export const oddsSortFn = defaultSortFn => (a, b) => {
    const v1 = getPriceSortValue(a);
    const v2 = getPriceSortValue(b);

    if (v1 === v2) {
        return defaultSortFn ? defaultSortFn(a, b) : 0;
    }
    return v1 < v2 ? -1 : 1;
};




// WEBPACK FOOTER //
// ./src/js/napsTable/utils/sort.js